import { DocumentError } from 'apiConnector/document/document';
import { BlotterPanelDocumentListItemLegacy } from 'components/shared/Blotter/BlotterPanel/blotter-panel-document-legacy/BlotterPanelDocumentListItemLegacy';
import { DocumentFormat } from 'epic/common-form/Documentation';
import type { IntlKey } from 'locales';
import { FC } from 'react';

import { TinySpinner } from '../TinySpinner/TinySpinner';
import type { ErrorDisplayContext } from './MultiLanguageDocumentItem';
import { MultiLanguageDocumentItem } from './MultiLanguageDocumentItem';
export interface LanguageDownload {
  language: string;
  documentFormat?: DocumentFormat;
  isDownloading: boolean;
  error?: DocumentError;
}
interface MultiLanguageDocumentProps {
  id?: string;
  className?: string;

  labelKey?: IntlKey;
  label?: string;

  e2e: string;

  isEnabled: boolean;
  languages: LanguageDownload[];
  onDocumentDownload: (language: string, documentFormat: DocumentFormat) => void;
  errorContext?: ErrorDisplayContext;
}

export const MultiLanguageDocument: FC<MultiLanguageDocumentProps> = ({
  id,
  e2e,
  labelKey,
  label,
  className,
  languages,
  errorContext,
  isEnabled,
  onDocumentDownload,
}) => {
  const formatsByLanguage = new Map<string, Set<DocumentFormat>>();

  languages.forEach(({ language, documentFormat }) => {
    if (!formatsByLanguage.has(language)) {
      formatsByLanguage.set(language, new Set());
    }
    if (documentFormat) {
      formatsByLanguage.get(language)!.add(documentFormat);
    }
  });

  const languagesWithMultipleFormats = Array.from(formatsByLanguage.entries())
    .filter(([_, formats]) => formats.size > 1)
    .map(([language]) => language);

  return (
    <BlotterPanelDocumentListItemLegacy nameKey={labelKey} name={label} className={className} e2e={e2e}>
      {languages.map(({ language, documentFormat, error, isDownloading }, index) =>
        isDownloading ? (
          <TinySpinner key={`${language}-${documentFormat}`} className="m-2 align-self-center" />
        ) : (
          <MultiLanguageDocumentItem
            id={id}
            key={`lang_${index}`}
            e2e={e2e}
            language={language}
            documentFormat={documentFormat ?? 'PDF'}
            error={error}
            onDocumentDownload={onDocumentDownload}
            isEnabled={isEnabled}
            errorContext={errorContext}
            withFormatIcon={languagesWithMultipleFormats.includes(language)}
          />
        ),
      )}
    </BlotterPanelDocumentListItemLegacy>
  );
};
